import { render } from "./ProjectShow.vue?vue&type=template&id=aafc7b14"
import script from "./ProjectShow.vue?vue&type=script&lang=js"
export * from "./ProjectShow.vue?vue&type=script&lang=js"
script.render = render

export default script